import { useDispatch, useSelector } from 'react-redux'
import React from 'react'
import cloneDeep from 'lodash/cloneDeep'
import {
  getRow0,
  getRow1,
  getRow2,
  getRow3,
  getRow4,
  getSelectedUnits,
} from '../../selectors'
import { SelectUnitRow } from '../../types'
import { actions } from '../../reducer'
import { getUnitsIndividual } from '../../../Units/selectors'

export const UseBuildRowsEffect = () => {
  const dispatch = useDispatch()
  const row0 = useSelector(getRow0)
  const row1 = useSelector(getRow1)
  const row2 = useSelector(getRow2)
  const row3 = useSelector(getRow3)
  const row4 = useSelector(getRow4)
  const selectedUnits = useSelector(getSelectedUnits)
  const individualUnits = useSelector(getUnitsIndividual)

  const cacheRef = React.useRef<any>(null)

  const onCheckUnavailable = React.useCallback(
    (data: SelectUnitRow[]) => {
      let row = cloneDeep(data).map((x) => {
        const _obj = individualUnits?.find(
          (y) => y.unitNumber === x.unitNumber && y.customerProfileId
        )
        x.isUnavailable = !(_obj == null)
        return x
      })

      selectedUnits.forEach((x) => {
        row = row.map((k) => {
          const checkMatch = x.size === k.size && !k.isUnavailable
          const isClimateEqual = x.isClimate === k.isClimate
          const isCoveredEqual = x.isCovered === k.isCovered
          if (
            (checkMatch && isClimateEqual) ||
            (checkMatch && isCoveredEqual)
          ) {
            k.isSelectable = true
          }
          return k
        })
      })

      return row
    },
    [selectedUnits, individualUnits]
  )

  React.useEffect(() => {
    if (
      cacheRef.current === null &&
      individualUnits &&
      individualUnits.length > 0
    ) {
      dispatch(
        actions.onAllRows({
          row0: onCheckUnavailable(row0),
          row1: onCheckUnavailable(row1),
          row2: onCheckUnavailable(row2),
          row3: onCheckUnavailable(row3),
          row4: onCheckUnavailable(row4),
        })
      )
      cacheRef.current = individualUnits
    }
  }, [onCheckUnavailable, dispatch, individualUnits, row0, row1, row2, row3, row4])
}
